const annoucementBarContainer = document.querySelector(
  "#brand-announcement-bar",
);
const announcementBar = document.querySelector("#rotating-announcement-bar");
let announcementArrows = announcementBar.querySelectorAll(
  ".announcement-bar__button",
);

const brandHeaderCta = announcementBar.querySelector(
  ".brand-header-cta--dsktp",
);

if (brandHeaderCta) {
  brandHeaderCta.addEventListener("click", () => {
    gtag({
      event: "swatch_plp_click",
      eventID: getEventId(),
    });
  });
}
let closeAnnouncementBtn = announcementBar.querySelector(
  ".announcement-bar__close",
);
let announcements = announcementBar.querySelectorAll(
  ".announcement-bar__message",
);

const announcementCtas = announcementBar.querySelectorAll(".announcement-cta");
announcementCtas?.forEach((cta) => {
  const ctaUrl = cta?.getAttribute("href");
  const ctaText = cta?.parentElement
    .querySelector("p")
    .textContent.trim()
    .replace(/\s+/g, " ");
  cta.addEventListener("click", () => {
    gtag("announcement_bar_click", {
      event: "announcement_bar_click",
      eventID: getEventId(),
      eventData: {
        ctaText,
        ctaUrl,
      },
    });
  });
});

let autoplayDuration =
  parseInt(announcementBar.dataset.autoplayInterval, 10) * 1000;
let enableAutoplay;
if (announcementBar.dataset.autoplay === "true" && announcements.length > 1) {
  enableAutoplay = true;
} else enableAutoplay = false;
let intervalBetweenAnnouncements;
let currentMessageIndex = 0;
let isAnnouncementClosed;

function checkIfannouncementBarIsClosed() {
  if (sessionStorage.getItem("announcement_closed")) {
    isAnnouncementClosed = sessionStorage.getItem("announcement_closed");
  } else {
    sessionStorage.setItem("announcement_closed", "false");
    isAnnouncementClosed = sessionStorage.getItem("announcement_closed");
  }
  if (isAnnouncementClosed === "true") {
    annoucementBarContainer.style.display = "none";
  }
}

function setAnnouncementInterval() {
  if (enableAutoplay) {
    intervalBetweenAnnouncements = setInterval(() => {
      const prevMessageIndex = currentMessageIndex;
      announcements[currentMessageIndex].classList.remove("move-right");
      announcements[currentMessageIndex].classList.add("move-left");
      setTimeout(() => {
        announcements[prevMessageIndex].classList.add("none");
      }, 250);

      if (currentMessageIndex < announcements.length - 1) currentMessageIndex++;
      else currentMessageIndex = 0;

      setTimeout(() => {
        announcements[currentMessageIndex].classList.remove("none");
      }, 300);

      setTimeout(() => {
        announcements[currentMessageIndex].classList.remove("move-right");
      }, 500);

      setTimeout(() => {
        announcements[prevMessageIndex].classList.add("move-right");
        announcements[prevMessageIndex].classList.remove("move-left");
      }, 500);
    }, autoplayDuration);
  }
}

function setCloseEventListener() {
  closeAnnouncementBtn.addEventListener("click", () => {
    annoucementBarContainer.style.display = "none";
    sessionStorage.setItem("announcement_closed", "true");
  });
}

function setArrowEventListeners() {
  announcementArrows.forEach((arrow) => {
    arrow.addEventListener("click", () => {
      const { direction } = arrow.dataset;
      clearInterval(intervalBetweenAnnouncements);

      // Track Click
      gtag({
        event: "annoucement_bar_scroll",
        eventData: {
          direction: direction,
          slideContent: announcements[currentMessageIndex].dataset.slideMessage,
        },
      });

      if (direction === "prev") {
        if (currentMessageIndex > 0) currentMessageIndex--;
        else currentMessageIndex = announcements.length - 1;
      } else if (direction === "next") {
        if (currentMessageIndex < announcements.length - 1)
          currentMessageIndex++;
        else currentMessageIndex = 0;
      }

      if (direction === "next") {
        if (currentMessageIndex === 0) {
          // Move current message to left overflow
          announcements[announcements.length - 1].classList.add("move-left");
          setTimeout(() => {
            announcements[announcements.length - 1].classList.add("none");
            announcements[announcements.length - 1].classList.remove(
              "move-left",
            );
            announcements[announcements.length - 1].classList.add("move-right");
          }, 250);

          announcements[currentMessageIndex].classList.remove("move-left");
          announcements[currentMessageIndex].classList.add("move-right");

          // Move right overflow to current message position
          setTimeout(() => {
            announcements[currentMessageIndex].classList.remove("none");
          }, 300);
          setTimeout(() => {
            announcements[currentMessageIndex].classList.remove("move-right");
          }, 500);
        } else {
          // Move current message to left overflow
          announcements[currentMessageIndex - 1].classList.remove("move-right");
          announcements[currentMessageIndex - 1].classList.add("move-left");
          setTimeout(() => {
            announcements[currentMessageIndex - 1].classList.add("none");
            announcements[currentMessageIndex - 1].classList.remove(
              "move-left",
            );
            announcements[currentMessageIndex - 1].classList.add("move-right");
          }, 250);

          announcements[currentMessageIndex].classList.remove("move-left");
          announcements[currentMessageIndex].classList.add("move-right");

          // Move right overflow to current message position
          setTimeout(() => {
            announcements[currentMessageIndex].classList.remove("none");
          }, 300);
          setTimeout(() => {
            announcements[currentMessageIndex].classList.remove("move-right");
          }, 500);
        }
      }

      if (direction === "prev") {
        if (currentMessageIndex === announcements.length - 1) {
          // Move current message to right overflow
          announcements[0].classList.add("move-right");
          setTimeout(() => {
            announcements[0].classList.add("none");
          }, 250);
          announcements[currentMessageIndex].classList.remove("move-right");
          announcements[currentMessageIndex].classList.add("move-left");

          // Move left overflow to current message position
          setTimeout(() => {
            announcements[currentMessageIndex].classList.remove("none");
          }, 300);
          setTimeout(() => {
            announcements[currentMessageIndex].classList.remove("move-left");
          }, 500);
        } else {
          // Move current message to right overflow
          announcements[currentMessageIndex + 1].classList.remove("move-left");
          announcements[currentMessageIndex + 1].classList.add("move-right");
          setTimeout(() => {
            announcements[currentMessageIndex + 1].classList.add("none");
          }, 250);
          announcements[currentMessageIndex].classList.remove("move-right");
          announcements[currentMessageIndex].classList.add("move-left");

          // Move left overflow to current message position
          setTimeout(() => {
            announcements[currentMessageIndex].classList.remove("none");
          }, 300);
          setTimeout(() => {
            announcements[currentMessageIndex].classList.remove("move-left");
          }, 500);
        }
      }
      setAnnouncementInterval();
    });
  });
}

function loadInitialMessage() {
  for (let i = 0; i < announcements.length; i++) {
    if (i !== 0) announcements[i].classList.add("move-right", "none");
  }
}

// Accounts for previewing changes within Shopify theme editor
if (window.Shopify.designMode) {
  document.addEventListener("shopify:section:load", () => {
    setTimeout(() => {
      announcementArrows = announcementBar.querySelectorAll(
        ".announcement-bar__button",
      );
      closeAnnouncementBtn = announcementBar.querySelector(
        ".announcement-bar__close",
      );
      announcements = announcementBar.querySelectorAll(
        ".announcement-bar__message",
      );
      autoplayDuration =
        parseInt(announcementBar.dataset.autoplayInterval, 10) * 1000;
      if (
        announcementBar.dataset.autoplay === "true" &&
        announcements.length > 1
      ) {
        enableAutoplay = true;
      } else enableAutoplay = false;
      currentMessageIndex = 0;
      checkIfannouncementBarIsClosed();
      loadInitialMessage();
      clearInterval(intervalBetweenAnnouncements);
      setAnnouncementInterval();
      setArrowEventListeners();
      setCloseEventListener();
    }, 100);
  });
}
checkIfannouncementBarIsClosed();
loadInitialMessage();
setAnnouncementInterval();
setArrowEventListeners();
setCloseEventListener();
